import { email, required, useGetIdentity, useRecordContext } from "ra-core";
import { BooleanInput } from "@/components/admin/boolean-input";
import { TextInput } from "@/components/admin/text-input";

import type { Sale } from "../types";

export function SalesInputs() {
  const { identity } = useGetIdentity();
  const record = useRecordContext<Sale>();
  const isCurrentUser = record?.id === identity?.id;

  return (
    <div className="space-y-4 w-full">
      <TextInput source="first_name" validate={required()} helperText={false} />
      <TextInput source="last_name" validate={required()} helperText={false} />
      <TextInput
        source="email"
        validate={[required(), email()]}
        helperText={false}
      />
      <BooleanInput
        source="administrator"
        readOnly={isCurrentUser}
        helperText={false}
      />
      <BooleanInput
        source="pending"
        readOnly={isCurrentUser}
        helperText={false}
      />
      <BooleanInput
        source="disabled"
        readOnly={isCurrentUser}
        helperText={false}
      />
    </div>
  );
}
